"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const react_final_form_1 = require("react-final-form");
const components_1 = require("../../components");
const RichTextField = ({ disabled, fullWidth, name, readOnly, validate, }) => {
    return (react_1.default.createElement(Box_1.default, { sx: {
            width: fullWidth ? '100%' : 'fit-content',
            padding: '0.5rem',
        } },
        react_1.default.createElement(react_final_form_1.Field, { name: name, validate: validate }, ({ input }) => react_1.default.createElement(components_1.RichTextEditor, { disabled: disabled, input: input, readOnly: !!readOnly }))));
};
exports.default = RichTextField;
